export const graphqlChannelMapping = {
  web: 'DESKTOP',
  tab: 'TABLET',
  mob: 'MOBILE',
} as const;
